export default {
  updateUi(state, payload) {
    state.ui = { ...state.ui, ...payload };
  },
  updateRemote(state, payload) {
    state.remote = { ...state.remote, ...payload };
  },
};
